import { where } from "firebase/firestore";
import { User } from "src/entities/user.entity";
import { FilterQueryBuilder } from "src/firebase/firestore/filterQueryBuilder";
import { Repository } from "src/firebase/firestore/repository";

class UserRepository extends Repository<User> {
  constructor() {
    super("users");
  }
  async studentsByOrganizationId(id: string) {
    return [];
  }

  async findByEmail(email: string): Promise<User | null> {
    const normalizedEmail = email.trim().toLowerCase();
    console.log("🔍 Looking for user with email:", normalizedEmail);
    const queryBuilder = new FilterQueryBuilder(this.collection);
    queryBuilder.where(where("email", "==", normalizedEmail));

    const queryResult = await this.findBy(queryBuilder.build());
    return queryResult.length === 1 ? queryResult[0] : null;
  }

  async findAllAdmins(): Promise<User[]> {
    const queryBuilder = new FilterQueryBuilder(this.collection);
    queryBuilder.where(where("roles", "array-contains", "ADMIN"));

    return this.findBy(queryBuilder.build());
  }
}

export const userRepository = new UserRepository();
